export default "__VITE_ASSET__2rITJ_XF__"